export const ACHIEVEMENT_RECORDS = '/achievement_records/' as const
export const ACHIEVEMENT_RECORDS_ALL = `${ACHIEVEMENT_RECORDS}all` as const
export const ACHIEVEMENT_RECORDS_TYPES = `${ACHIEVEMENT_RECORDS}types` as const
export const ACHIEVEMENT_RECORDS_CHANGE_STATUS = `${ACHIEVEMENT_RECORDS}change/status` as const
export const ACHIEVEMENT_RECORDS_STUDENT = `${ACHIEVEMENT_RECORDS}student/` as const
